export const RESTRICTION_TYPE = {
  NONE: 'NONE',
  PRIVILEGED_ONLY: 'PRIVILEGED_ONLY',
  SELECTED_ONLY: 'SELECTED_ONLY',
};

export const RESTRICTION_OPTIONS = [
  {
    label: 'Everyone can post',
    value: RESTRICTION_TYPE.NONE,
  },
  {
    label: 'Only admins and managers can post',
    value: RESTRICTION_TYPE.PRIVILEGED_ONLY,
  },
  {
    label: 'Only specified members can post',
    value: RESTRICTION_TYPE.SELECTED_ONLY,
  },
];

export const KEYS = {
  K: 75,
  ENTER: 13,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
};

export const MANUAL_CANCEL = 'manual cancel';
export const BACKDROP_CLICK = 'backdrop click';

export const MAX_PINNED_CONVERSATIONS = 4;

// Conversations list heights //
export const CONVERSATIONS_LIST_HEIGHTS = {
  startConversationButton: 36,
  searchField: 51,
  topSection: 107,
  archivedConversations: 50,
  conversationGroupMargin: 30,
  conversationGroupHeader: 54,
  conversationRow: 30,
};

export const CONVERSATION_TEXTS = {
  deleteConversation: {
    title: 'Check to confirm you understand the following information will be deleted:',
    conditions: [
      'Selected conversation',
      'All message history of the conversation will be deleted',
    ],
  },
};

export const CONVERSATION_MEMBERS_OPEN_CACHE_KEY = 'conversations:membersPanelOpenById';
